var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAppleBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAppleBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Splash-screen",
    transform: "translate(-111.000000, -530.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-186.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(186.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(10.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(52.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAppleBlack",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51536182,23.9552652 C2.95012477,23.9347255 0.00102932002,16.6568715 0.00102932002,12.9504305 C0.00102932002,6.89597008 4.54290393,5.57048662 6.29330942,5.57048662 C7.08214286,5.57048662 7.92445415,5.88026516 8.66738927,6.15439179 C9.18691516,6.34561138 9.72422021,6.54300689 10.0230505,6.54300689 C10.2019183,6.54300689 10.6234248,6.37508736 10.9955708,6.22775424 C11.7892233,5.91179978 12.7768091,5.51911419 13.9268403,5.51911419 C13.9288989,5.51911419 13.9316594,5.51911419 13.9336712,5.51911419 C14.7924049,5.51911419 17.3961167,5.70757333 18.9614785,8.05835312 L19.3281503,8.60936684 L18.8004367,9.00757333 C18.0465533,9.576413 16.6710075,10.6140612 16.6710075,12.6694729 C16.6710075,15.1038615 18.2288366,16.0400749 18.9772458,16.4903556 C19.3076107,16.689108 19.6495789,16.8940362 19.6495789,17.3422583 C19.6495789,17.6349127 17.3138646,23.9189582 13.9220212,23.9189582 C13.0920618,23.9189582 12.5053961,23.6694885 11.9879289,23.4494947 C11.4643325,23.2267405 11.0126482,23.0348659 10.2662976,23.0348659 C9.88797567,23.0348659 9.4095758,23.2137337 8.90310356,23.4035964 C8.21097941,23.6619089 7.4275733,23.9552652 6.53866188,23.9552652 L6.51536182,23.9552652 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2861666,-4.26325641e-14 C14.3745009,3.18509046 12.0966625,5.39475983 9.82149095,5.25617592 C9.44658453,2.71436369 12.0963818,-4.26325641e-14 14.2861666,-4.26325641e-14 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppleBlack);
export default __webpack_public_path__ + "static/media/icAppleBlack.fc8bc0cb108ff2e28fe14e6a9a5748e8.svg";
export { ForwardRef as ReactComponent };